import { useCallback, useMemo, useRef } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { createDatasource } from './useCascaderDatasource';
export function useMultipleCascaderDatasource(value, datasource, onChange) {
  var hashMap = useRef({});
  var data = useMemo(function () {
    hashMap.current = {};
    return createDatasource(datasource, [], hashMap.current);
  }, [datasource]);
  var onChangeCallback = useRefCallback(onChange);
  var handleChange = useCallback(function (value) {
    var newVal = value.map(function (val) {
      return hashMap.current[val];
    });
    onChangeCallback(newVal);
  }, []);
  var newVal = [];
  var stringVal = value.map(function (item) {
    return item.join(',');
  });
  Object.keys(hashMap.current).forEach(function (id) {
    if (stringVal.indexOf(hashMap.current[id].join(',')) >= 0) {
      newVal.push(id);
    }
  });
  return {
    value: newVal,
    datasource: data,
    onChange: handleChange
  };
}